import React from 'react';

const PrioritySVG = ({ color = 'black', className, onClick, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      onClick={onClick}
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.8136 2.03363C10.812 1.03201 9.18802 1.03201 8.1864 2.03363L2.03363 8.18639C1.03201 9.18802 1.03201 10.812 2.03363 11.8136L8.18639 17.9664C9.18802 18.968 10.812 18.968 11.8136 17.9664L17.9664 11.8136C18.968 10.812 18.968 9.18802 17.9664 8.1864L11.8136 2.03363ZM7.27959 1.12683C8.78204 -0.375612 11.218 -0.375608 12.7204 1.12683L18.8732 7.27959C20.3756 8.78203 20.3756 11.218 18.8732 12.7204L12.7204 18.8732C11.218 20.3756 8.78203 20.3756 7.27959 18.8732L1.12683 12.7204C-0.375612 11.218 -0.375608 8.78203 1.12683 7.27959L7.27959 1.12683ZM10 5.41935C10.3541 5.41935 10.6412 5.70643 10.6412 6.06056V11.3103C10.6412 11.6644 10.3541 11.9515 10 11.9515C9.64587 11.9515 9.35879 11.6644 9.35879 11.3103V6.06056C9.35879 5.70643 9.64587 5.41935 10 5.41935ZM10 13.8688C10.3541 13.8688 10.6412 14.1559 10.6412 14.51V14.6093C10.6412 14.9635 10.3541 15.2506 10 15.2506C9.64587 15.2506 9.35879 14.9635 9.35879 14.6093V14.51C9.35879 14.1559 9.64587 13.8688 10 13.8688Z"
        fill={color}
      />
    </svg>
  );
};

export default PrioritySVG;
